import RedirectSvg from '@assets/images/icons/icon-redirect.svg?react';

import * as S from './vehicle-informations.styles';

import type { TVehicleInformationsConfig } from './vehicle-informations.types';
import { useVehicleInformationsLogic } from './vehicle-informations.hook';
import { VEHICLE_INFORMATIONS_STRINGS } from './utils/vehicle-informations.constants';

const VehicleInformations: React.FC<TVehicleInformationsConfig> = ({ lead }) => {
	const {
		isDesktop,
		isLeadInvalid,
		vehicleImage,
		city,
		state,
		title,
		formattedPrice,
		formattedOdometer,
		year,
		advertiseUrl,
	} = useVehicleInformationsLogic({ lead });

	if (isLeadInvalid) return null;

	return (
		<S.VehicleInfo data-qa="vehicle-info-panel">
			<S.VehicleContent>
				<S.VehicleImage data-qa="vehicle-info-image" src={vehicleImage} alt={VEHICLE_INFORMATIONS_STRINGS.VEHICLE_PHOTO_ALT} />
				<div>
					<S.VehicleDetails nowrap>{title}</S.VehicleDetails>
					<S.VehicleDetails>
					{formattedPrice ? `${formattedPrice} | ` : ''}
					{year ? `${year} | ` : ''}
					{formattedOdometer ? `${formattedOdometer} ${VEHICLE_INFORMATIONS_STRINGS.KM_UNIT} | ` : ''}
						{city && state ? `${city}/${state}` : ''}
					</S.VehicleDetails>
				</div>
			</S.VehicleContent>
			<S.VehicleLink data-qa="vehicle-info-link" href={advertiseUrl} target="_blank" rel="noreferrer">
				<RedirectSvg />
				{isDesktop && VEHICLE_INFORMATIONS_STRINGS.SEE_AD}
			</S.VehicleLink>
		</S.VehicleInfo>
	);
};

VehicleInformations.displayName = 'VehicleInformations';
export { VehicleInformations };
